import { styled, TableCell } from "@mui/material";

export const MyHeadCellRightStyled = styled(TableCell)(
    ({ theme }) => ({
        color: theme.palette.primary.contrastText,
        borderTopRightRadius: theme.shape.borderRadius
    })
);